const PremiumStar = ({ size = 'sm' }) => {
  const sizeClasses = {
    sm: 'w-5 h-5',
    xs: 'w-4 h-4'
  };
  return (
    <span
      className={`inline-flex items-center justify-center rounded-full bg-amber-500 text-white dark:bg-amber-400 ${sizeClasses[size] || sizeClasses.sm}`}
    >
      <svg viewBox="0 0 20 20" fill="currentColor" className="w-3.5 h-3.5">
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
      </svg>
    </span>
  );
};

const PremiumName = ({
  name,
  isPremium,
  premiumColor,
  className = '',
  nameClassName = '',
  iconSize = 'sm',
  showIcon = true
}) => {
  const style = isPremium && premiumColor ? { color: premiumColor } : undefined;

  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <span className={`truncate ${nameClassName}`} style={style}>
        {name}
      </span>
      {isPremium && showIcon && <PremiumStar size={iconSize} />}
    </span>
  );
};

export default PremiumName;
